import './are-you-sure-you-want-to-delete-this-workflow.css'

const AreYouSureYouWantToDeleteThisWorkflow = ({setAreYouSure, deleteATemplate, templateId}) => {
    console.log(templateId)
    return (
        <div className='are-you-sure-you-want-to-delete-this-workflow__wrapper'>
            <div className='are-you-sure-you-want-to-delete-this-workflow'>
                <div className='are-you-sure-you-want-to-delete-this-workflow__question-mark-icon'>?</div>
                <div className='are-you-sure-you-want-to-delete-this-workflow__title'>Delete Template?</div>
                <div className='are-you-sure-you-want-to-delete-this-workflow__subtitle'>Are you sure you want to delete this template?</div>
                <div className='are-you-sure-you-want-to-delete-this-workflow__btn-wrapper'>
                    <div className='are-you-sure-you-want-to-delete-this-workflow__btn__no' onClick={() => setAreYouSure(false)}>No</div>
                    <div className='are-you-sure-you-want-to-delete-this-workflow__btn__yes' onClick={() => deleteATemplate(templateId)}>Delete</div>
                </div>
            </div>
        </div>
    )
}
export default AreYouSureYouWantToDeleteThisWorkflow;